/**
 * Api error codes reported by the transcript turnaround controller
 */
export var TranscriptTurnaroundErrorCode;
(function (TranscriptTurnaroundErrorCode) {
    /**
     * Indicates an attempt to remove a turnaround from a court system or billing group, where it is the sole Turnaround.
     */
    TranscriptTurnaroundErrorCode["MinimumNumberOfTurnaroundsReached"] = "transcript-turnaround/MinimumNumberOfTurnaroundsReached";
    /**
     * Indicates an attempt to add a turnaround to a court system or billing group which contains the maximum number
     * of turnarounds.
     */
    TranscriptTurnaroundErrorCode["MaximumNumberOfTurnaroundsReached"] = "transcript-turnaround/MaximumNumberOfTurnaroundsReached";
    /**
     * Indicates an attempt to add a turnaround with a name that already exists in the court system or billing group.
     */
    TranscriptTurnaroundErrorCode["TurnaroundNameAlreadyExists"] = "transcript-turnaround/TurnaroundNameAlreadyExistsError";
})(TranscriptTurnaroundErrorCode || (TranscriptTurnaroundErrorCode = {}));
